import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    ul: {
        justifyContent: "space-around",
    },
}));
